<script setup>
import axios from "axios";
import List from './List.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const title = ref('常见问题');
const list = ref([]);

onMounted(() => {
  // 获取常见问题
  const questionQueryData = {
    productId: productId.value,
    page: 0,
    size: 5,
    topState: 1,
    sort: 'positionTop',
  };
  axios.get('/question', { params: questionQueryData }).then(res => {
    if (res.data && res.data.content) {
      list.value = res.data.content;
      console.log('faq questions', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });
});
</script>

<template>
  <List :title="title" :list="list" title-class="first"/>
</template>

<style scoped lang="scss">

</style>
